import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import TicketNotesModal from '../Modals/TicketNotesModal';

export default class TicketNote extends Component {
  view() {
    const ticket = this.attrs.ticket;

    // No note or no permission to view note
    if (!app.forum.attribute('canViewTickets') || ticket.privateNote() === '') return null;

    return (
      <div class="Post-body TicketNotification TicketNotificationTop">
        <blockquote>
          <p>
            <i className={'far fa-sticky-note TicketNotificationIcon'} />

            <span style={{ fontWeight: 'bold', fontSize: 15 }}>
              {app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.title')}
            </span>

            <button
              className={'Button'}
              style={{ float: 'right' }}
              onclick={() =>
                app.modal.show(TicketNotesModal, {
                  ticket,
                })
              }
            >
              {app.translator.trans('v17development-flarum-support.forum.tickets.fields.private_note.edit_button')}
            </button>
          </p>

          <p style={{ 'white-space': 'pre' }}>{ticket.privateNote()}</p>
        </blockquote>
      </div>
    );
  }
}
